<template>
  <div class="hello">
    <div class="login">
      <i class="el-icon-close" @click="close"></i>
      <img class="logo" src="../../src/assets/newlogo.png" alt="">
      <div class="login_main" v-show="current==0" style="padding-bottom: 20px;">
        <input type="text" v-model="loginForm.mobile" placeholder="手机号/会员号">
        <input type="password" v-model="loginForm.pass" placeholder="输入密码">
        <button class="login_btn" @click="login">登录</button>
        <div class="change flex">
          <span @click="current=1">注册</span><span @click="current=2">忘记密码</span>
        </div>
        <div class="xieyi">
          <img src="../assets/selected.png" alt="">
          登录代表同意
          <span style="color: #C10B17;text-decoration: underline;" @click="xieyi">《鸿之博云智选》用户服务协议</span>
        </div>
      </div>
      <!-- 注册 -->
      <div class="login_main" v-show="current==1">
        <input type="text" placeholder="手机号" v-model="registered.mobile">
        <div>
          <input style="position: relative;" type="text" placeholder="短信验证码" v-model="registered.code">
          <button class="yzm" @click="getCode(0)" :disabled="isSend">
            {{second==60?'获取验证码':second+'秒后重发'}}
          </button>
        </div>
        <input type="text" placeholder="请输入用户名" v-model="registered.username">
        <input type="text" placeholder="输入密码" v-model="registered.password">
        <input type="text" placeholder="再次确认密码" v-model="registered.repassword">
        <button class="login_btn" @click="regist">注册</button>
        <div class="change" style="text-align: left;">
          <span style="width: 100%;text-align: left;" @click="current=0">登录</span>
        </div>
      </div>
      <!-- 忘记密码 -->
      <div class="login_main" v-show="current==2">
        <input type="text" placeholder="手机号" v-model="resetForm.mobile">
        <div>
          <input style="position: relative;" type="text" placeholder="短信验证码" v-model="resetForm.code">
          <button class="yzm" @click="getCode(1)" :disabled="isSend">
            {{second==60?'获取验证码':second+'秒后重发'}}
          </button>
        </div>
        <input type="text" placeholder="输入密码" v-model="resetForm.password">
        <input type="text" placeholder="再次确认密码" v-model="resetForm.repassword">
        <button class="login_btn" @click="reset">确定</button>
        <div class="change" style="text-align: left;">
          <span style="width: 100%;text-align: left;" @click="current=0">登录</span>
        </div>
      </div>
    </div>
    <el-dialog title="VIP付费用户使用说明" :visible.sync="dialogVisible" style="z-index: 20000;" width="700px"
      :before-close="handleClose">
      <p v-html="data.content"></p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: [],
        current: 0,
        loginForm: {
          mobile: '',
          pass: ''
        },
        second: 60,
        text: '获取验证码',
        isSend: false,
        dialogVisible: false,
        registered: {
          mobile: '',
          code: '',
          username: '',
          password: '',
          repassword: '',
          reference_code: ''
        },
        resetForm: {
          mobile: '',
          code: '',
          repassword: '',
          password: ''
        }
      }
    },
    created() {

    },
    methods: {
      xieyi() {
        this.$http.newsDetail({
          id: 17
        }).then(res => {
          this.data = res.data
          this.dialogVisible = true
        })
      },
      reset() {
        if (this.resetForm.password != this.resetForm.repassword) {
          this.$message.error('两次密码输入不一致!')
          return
        }
        this.$http.repassCode({
          "mobile": this.resetForm.mobile,
          'code': this.resetForm.code,
          'password': this.resetForm.password,
          'repassword': this.resetForm.repassword
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('修改成功，请重新登录')
            this.current = 0
            localStorage.clear()
          }

        })
      },
      regist() {
        if (this.registered.password != this.registered.repassword) {
          this.$message.error('两次密码输入不一致!')
          return
        }
        if (this.registered.username == '') {
          this.$message.error('请输入用户名!')
          return
        }
        this.$http.loginCode({
          "mobile": this.registered.mobile,
          'code': this.registered.code,
          'password': this.registered.password,
          'repassword': this.registered.repassword,
          'username': this.registered.username
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('注册成功,请登录')
            this.current = 0
          }
        })
      },
      getCode(num) {
        if (this.registered.mobile.length != 11 && num == 0) {
          this.$message.error('请输入正确的手机号')
          return
        }
        if (this.resetForm.mobile.length != 11 && num == 1) {
          this.$message.error('请输入正确的手机号')
          return
        }
        this.isSend = true
        this.$http.smsCode({
          scene: num == 1 ? 'pass' : 'reg',
          mobile: num == 1 ? this.resetForm.mobile : this.registered.mobile
        }).then(res => {
          this.$message.success('验证码发送成功')
        })
        let timer = setInterval(() => {
          this.second--
          if (this.second <= 0) {
            this.isSend = false
            clearInterval(timer)
            this.second = 60
          }
        }, 1000)
      },
      login() {
        if (this.current == 0) {
          this.$http.loginPass(this.loginForm).then(res => {
            if (res.code == 200) {
              this.$message.success('登录成功')
              if (res.data.score == null) {
                this.$message.error('请先填写基本信息！')
                this.$router.push('/personalCenter')
              }
              this.close()
              localStorage.setItem('token', res.data.token)
              setTimeout(() => {
                this.$http.getUserInfo().then(res => {
                  this.$store.commit('login_over', true);
                  localStorage.setItem('userInfo', JSON.stringify(res.data))
                  this.$router.go(0)
                })
              })
            }
          })
        }
      },
      close() {
        this.$store.commit('login', false);
      }
    }
  }
</script>

<style scoped lang="scss">
  .login {
    width: 522px;
    background: #FFFFFF;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -261px;
    margin-top: -278px;
    z-index: 10001;
    box-shadow: 0px 0px 10px 0px rgba(29, 24, 7, 0.05);
    text-align: center;

    .login_main {
      .yzm {
        position: absolute;
        width: 107px;
        height: 37px;
        border: 1px solid #C10B17;
        border-radius: 10px;
        color: #C10B17;
        font-size: 16px;
        background-color: #FFFFFF;
        right: 50px;
      }
    }

    .xieyi {
      text-align: left;
      margin-left: 25px;

      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }

    .change {
      width: 100%;
      margin: 19px 53px 106px 53px;
      justify-content: space-between;

      span {
        // display: inline-block;
      }

      &>span:nth-child(1) {
        width: 50%;
        color: #C10B17;
        text-align: left;
      }

      &>span:nth-child(2) {
        width: 50%;
        color: #999999;
        // text-align: left;
      }
    }

    input {
      width: 421px;
      height: 50px;
      border: none;
      margin-bottom: 30px;
      border-bottom: 1px solid #E6E6E6;
      outline: none !important;
    }

    .login_btn {
      width: 410px;
      height: 50px;
      background: #C10B17;
      border-radius: 10px;
      color: #FFFFFF;
      font-size: 18px;
    }

    i {
      position: absolute;
      right: 10px;
      top: 10px;
    }

    .logo {
      margin: 30px 0 30px 0;

    }

  }
</style>
<style>
  .el-dialog__wrapper {
    z-index: 20000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue